"use client";

import "./spinner.css";

import React from "react";
import { cn } from "@/lib/utils";

interface SpinnerProps {
  size?: number;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 18,
  className,
}) => {
  const width = size;
  const height = size;

  const halfWidth = width / 2;
  const halfHeight = height / 2;
  const barWidth = width * 0.08;
  const barHeight = height * 0.22;
  const top = height * 0.05;
  const left = width / 2 - barWidth / 2;

  const spinnerStyle: React.CSSProperties = {
    width: `${width}px`,
    height: `${height}px`,
  };

  const afterStyle: React.CSSProperties = {
    top: `${top}px`,
    left: `${left}px`,
    width: `${barWidth}px`,
    height: `${barHeight}px`,
  };

  return (
    <div className={cn('flex justify-center items-center', className)}>
      <div className={cn("lds-spinner")} style={spinnerStyle}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            style={{
              transformOrigin: `${halfWidth}px ${halfHeight}px`,
            }}
          >
            <div style={afterStyle} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Spinner;